import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
const root = document.getElementById("root");
if (root) createRoot(root).render(<App />);

// Offline cache — only register on the live deployment, never inside the
// Lovable preview iframe (service workers cause stale builds there).
if (typeof window !== "undefined" && "serviceWorker" in navigator) {
  const inIframe = (() => {
    try { return window.self !== window.top; } catch { return true; }
  })();
  const host = window.location.hostname;
  const isPreview =
    host.includes("lovableproject.com") ||
    host.includes("lovable.app") ||
    host === "localhost" ||
    host === "127.0.0.1";

  if (!inIframe && !isPreview) {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw.js").catch(() => {});
    });
  } else {
    navigator.serviceWorker.getRegistrations().then((regs) => regs.forEach((r) => r.unregister()));
  }
}
